import React, { createElement } from "react";
import { Button } from 'antd';
import './index.scss';
class GrtExampleButtonClass extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (<Button className="test" type={this.props.type}>{this.props.type}</Button>);
    }
}
export default GrtExampleButtonClass;
